import React from 'react';
import SADatePicker from "../../common/input/SADatePicker";
import SATimePicker from "../../common/input/SATimePicker";
import {injectIntl} from "react-intl";
import SAInputComponent from "../../common/input/SAInputComponent";

class RentalAssignContractDates extends React.Component {

  render() {
    const {intl: {formatMessage}, startDate, startTime, endDate, endTime, onDateChange, onTimeChange, error = {}} = this.props;
    const errors = error.content || {};

    return (
      <div>
        <div className="row">
          <div className="col-md-6 col-xxl-6">
          <SAInputComponent  label={formatMessage({id: 'placeholder.startDate'})}>
            <SADatePicker onChange={(e) => onDateChange(e, 'contractStartDate')} value={startDate} error={errors.contractStartDate}/>
          </SAInputComponent>
          </div>
          <div className="col-md-6 col-xxl-6">
          <SAInputComponent label={formatMessage({id: 'placeholder.startTime'})}>
            <SATimePicker onChange={(e) => onTimeChange(e, 'contractStartTime')} value={startTime} error={errors.contractStartTime}/>
          </SAInputComponent>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6 col-xxl-6">
          <SAInputComponent label={formatMessage({id: 'placeholder.endDate'})}>
            <SADatePicker onChange={(e) => onDateChange(e, 'contractEndDate')} value={endDate} error={errors.contractEndDate}/>
          </SAInputComponent>
          </div>
          <div className="col-md-6 col-xxl-6">
          <SAInputComponent label={formatMessage({id: 'placeholder.endTime'})}>
            <SATimePicker onChange={(e) => onTimeChange(e, 'contractEndTime')} value={endTime} error={errors.contractEndTime}/>
          </SAInputComponent>
          </div>
        </div>
      </div>
    )
  }
}

export default injectIntl(RentalAssignContractDates);



// WEBPACK FOOTER //
// ./src/components/interventiondetail/rentalassign/RentalAssignContractDates.js